import { WinCriteriaType } from "Constants/WinCriteria";
import { report } from "report";
import { ICardsState, StreakReward } from "State/Card/ICardState";
import { IGameState } from "State/Game/IGameState";
import LoadCardData from "System/Card/LoadCardData";
import { ILevelDataFile } from "System/Level/Data/ILevelDataFile";
import CardsHelper from "Utility/CardsHelper";
import { IWinCriteriaData } from "../ILevelState";
import LevelStateHelper from "../LevelStateHelper";
import { LevelStatus } from "../LevelStatus";
import CardStateHelper from "State/Card/CardStateHelper";
import { FTUXStateHelper } from "State/Game/FTUX/FTUXStateHelper";
import { track } from "Utility/Tracking/Track";

export function levelStart(state: IGameState, levelData: ILevelDataFile): IGameState {
    try {
        console.log('Level loading');
        const stars = [
            levelData.settings.star_1,
            levelData.settings.star_2,
            levelData.settings.star_3,
        ];
        const winCriteria: IWinCriteriaData[] = levelData.settings.win_criteria
            ? levelData.settings.win_criteria
            : [{ type: WinCriteriaType.CLEAR_ALL }];

        let stackCards: number[] = [];

        // Needed for levels that don't have preset decks
        if (!Array.isArray(levelData.settings.cards_in_stack)) {
            const cardsInStack: number =
                levelData.settings.cards_in_stack === '0'
                    ? 1
                    : Number(levelData.settings.cards_in_stack);
            stackCards = [
                ...new Array(
                    // Create Array of length equal to the amount of cards in stack
                    cardsInStack
                ),
                //Map values to -1 for random assortments except first value which should be set to the initial card value
            ].map((card, index) => (index === 0 ? levelData.settings.initial_card_value || -1 : -1));
        } else {
            stackCards = levelData.settings.cards_in_stack.slice();
        }

        const cardData = LoadCardData(
            {
                cardsInPlay: levelData.cards,
                cardsInStack: stackCards,
            },
            new CardsHelper()
        );
        const cardsState: ICardsState = {
            cards: {
                ...cardData.cardsInPlay,
                ...cardData.cardsInStack,
            },
            inPlay: Object.values(cardData.cardsInPlay).map(c => c.id),
            inStack: Object.values(cardData.cardsInStack).map(c => c.id),
            folded: [],
            discarded: [],
            turns: 0,
            tasks: [],
            turnScore: 0,
            undoHistory: [],
            matchSequence: [],
            streakEnabled: false,
            streakReward: StreakReward.OneCard,
            streakScore: 0,
        };

        state = {
            ...state,
            levelState: {
                ...state.levelState,
                status: LevelStatus.LOADED,
                cardsState: cardsState,
                stars: stars,
                firstAttempt: LevelStateHelper.isFirstLevelAttempt(
                    state,
                    state.levelState.levelNumber,
                    state.levelState.levelType
                ),
                winCriteria,
            },
        };

        state = CardStateHelper.onLevelLoaded(state);

        state = LevelStateHelper.getCoinRewardAmount(state);
        state = LevelStateHelper.ensureBoosterUses(state);
        state = LevelStateHelper.getBoosterPrices(state);
        state = LevelStateHelper.useExtraCardBoosters(state);

        // FTUX tasks and level unlocks.
        state = FTUXStateHelper.setLevelTasks(state);
        state = FTUXStateHelper.setLevelComponents(state);

        track('mLevelMoves', state.levelState.cardsState.inStack.length);

        return state;
    } catch (error) {
        report('Failed to load level', {
            once: true,
            sampleRate: 0.1,
            error,
            fingerprint: 'LevelSystem:handleStateChanged:FailedToLoadLevel',
            tags: {
                levelNumber: state.levelState.levelNumber,
            },
        });

        return state;
    }
}